<template>
    <div class="space-y-6">
      <!-- Imagem do Mestre Rafael -->
      <div class="flex justify-center">
        <img 
          src="https://firebasestorage.googleapis.com/v0/b/dark-numerology-prod.firebasestorage.app/o/assets%2Fimages%2Fmestre_rafael.webp?alt=media&token=00bbc61c-f3df-4482-be4f-ff88e2bc2458" 
          alt="Mestre Rafael Arcano"
          class="shadow-lg"
        />
      </div>

      <div class="text-center space-y-4">
        <p class="text-gray-700">
          Mestre Rafael Arcano é um renomado especialista em Numerologia Pitagórica com mais de 15 anos de experiência.
          Formado em Filosofia Hermética e com especialização em Matemática Sagrada, combina conhecimentos ancestrais com abordagens contemporâneas.
        </p>
      </div>
    </div>
  </template>
  
  <style scoped>
  /* Estilos removidos pois não são mais necessários */
  </style>